import { render, staticRenderFns } from "./BindsBottomBarItem.vue?vue&type=template&id=d4592fcc&"
import script from "./BindsBottomBarItem.vue?vue&type=script&lang=js&"
export * from "./BindsBottomBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports